/* 🌸 "Vistos recientemente" — se guarda en el teléfono de la clienta y se pinta en el menú y al pie de las
   páginas (7-oct-2026). Nada de esto sale del teléfono: es localStorage, no viaja a ningún servidor. */
(function () {
  function leer() { try { var a = JSON.parse(localStorage.getItem('ps_recent') || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  // el handle y el texto vienen del propio navegador, pero se limpian igual antes de volver a pintarlos
  function limpiaHandle(h) { return /^[a-z0-9-]{1,120}$/i.test(h || '') ? h : ''; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* og:image viene con http:// y la tienda es https: así el navegador la bloquea por mezclar seguro con
     inseguro, y la fila salía con cuadros grises. Se fuerza a https y se pide chica (ahorra datos). */
  function imgOk(u) {
    u = String(u || '').replace(/^http:\/\//i, 'https://');
    if (!/^(https:\/\/|\/\/|\/)[^"'<>\s]*$/.test(u)) return '';
    if (/cdn\.shopify|\/cdn\/shop\//.test(u) && !/[?&]width=/.test(u)) u += (u.indexOf('?') >= 0 ? '&' : '?') + 'width=320';
    return u;
  }

  var aqui = '';
  try {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (m) {
      aqui = limpiaHandle(m[1]);
      var img = (document.querySelector('.product__media img, .product-media img') || {}).currentSrc || (document.querySelector('meta[property="og:image"]') || {}).content || '';
      var tt = ((document.querySelector('meta[property="og:title"]') || {}).content || document.title).split(' – ')[0].split(' | ')[0];
      if (aqui) {
        var a = leer().filter(function (x) { return x && x.h !== aqui; });
        a.unshift({ h: aqui, t: String(tt || '').slice(0, 90), i: String(img || '').slice(0, 400) });
        localStorage.setItem('ps_recent', JSON.stringify(a.slice(0, 12)));
      }
    }
  } catch (e) {}

  function pintar() {
    var cajas = document.querySelectorAll('[data-recent]');
    if (!cajas.length) return;
    // en la página de un producto no tiene caso repetirlo a él mismo
    var a = leer().filter(function (x) { return x && limpiaHandle(x.h) && x.h !== aqui; });
    for (var k = 0; k < cajas.length; k++) {
      var box = cajas[k], row = box.querySelector('[data-recent-row]');
      if (!row) continue;
      if (!a.length) { box.hidden = true; continue; }
      box.hidden = false;
      row.innerHTML = a.slice(0, 10).map(function (x) {
        var u = imgOk(x.i);
        return '<a href="/products/' + esc(x.h) + '">' + (u ? '<img src="' + esc(u) + '" alt="" loading="lazy">' : '<span class="ps-vistos__sin"></span>') + '<span>' + esc(x.t) + '</span></a>';
      }).join('');
    }
  }
  /* Menú de dos niveles (estilo Lulus): tocar "Vestidos" entra a su pantalla, la flecha regresa.
     Se hace con hidden, no con display en CSS, para que el lector de pantalla tampoco lea lo oculto. */
  function niveles() {
    var menu = document.querySelector('[data-menu]'); if (!menu || menu.dataset.ok) return; menu.dataset.ok = '1';
    var todos = menu.querySelectorAll('.ps-menu__nivel');
    function mostrar(n) {
      for (var i = 0; i < todos.length; i++) {
        var es = todos[i].getAttribute('data-nivel') === n;
        todos[i].hidden = !es;
        todos[i].classList.toggle('on', es);
      }
      menu.scrollTop = 0;
      var cont = menu.closest('.menu-drawer__inner, .drawer__inner'); if (cont) cont.scrollTop = 0;
    }
    menu.addEventListener('click', function (e) {
      var ir = e.target.closest('[data-ir]');
      if (ir) { e.preventDefault(); mostrar(ir.getAttribute('data-ir')); return; }
      if (e.target.closest('[data-volver]')) { e.preventDefault(); mostrar('raiz'); }
    });
  }
  function arranca() { pintar(); niveles(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca); else arranca();
})();
